import script from "./ProjectsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsPage.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsPage.vue?vue&type=style&index=0&id=b165000c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b165000c"]])

export default __exports__